import styled, { css } from 'styled-components';
import Layout from 'antd/es/layout';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const TimeWrapper = styled.div`
  width: 90px;
  position: relative;
`;

export const TimepickerWrapper = styled.div`
  min-width: 125px;
  position: relative;
`;

export const StyledLayout = styled(Layout)<{
  isHomePage?: boolean;
  $whiteBg?: boolean;
}>`
  &&& {
    background-color: ${({ $whiteBg, theme }) =>
      $whiteBg ? theme.palette.white : 'white'};
    max-width: 1200px;
    display: flex;
    justify-content: center;

    ${({ isHomePage }) =>
      isHomePage &&
      css`
        margin-top: 38px;

        @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
          margin-top: 14px;
        }
      `};
  }
`;

export const StyledContent = styled.div<{
  direction?: boolean;
  alignVertical?: boolean;
}>`
  display: flex;
  flex-direction: ${({ direction }) => (direction ? 'column' : 'row')};
  gap: 12px;

  ${({ alignVertical }) =>
    alignVertical &&
    css`
      flex-direction: column;
    `}
`;

export const DateWrapper = styled.div<{ alignVertical?: boolean }>`
  display: flex;
  position: relative;
  ${({ theme }) => theme.mediaQueries.DESKTOP} {
    width: 100%;
    justify-content: space-between;
  }

  ${({ alignVertical }) =>
    alignVertical &&
    css`
      flex-direction: column;
      gap: 12px;

      .is-bordered {
        border: 1px solid #000;
      }

      .car-rental-time-picker {
        width: 100%;

        & > div {
          width: 100%;
        }
      }
    `}
`;

export const ButtonWrapper = styled.div<{ alignVertical?: boolean }>`
  width: ${({ alignVertical }) => (alignVertical ? '100%' : '140px')};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;
export const CarRentalFooter = styled.div`
  height: 300px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey200} !important;
`;

export const CheckboxWrapper = styled.div`
  margin-bottom: 12px;
  width: 270px;

  .checkbox-desktop {
    margin-top: 12px;
  }
`;
